import { parsePhoneNumber } from 'libphonenumber-js';

export function formatPhone(phone: string): string {
  try {
    return parsePhoneNumber(phone).formatInternational();
  } catch (error: unknown) {
    console.warn(`Could not parse phone: ${phone}`, error);
    return phone;
  }
}
